<template>
  <div class="pvflex flex flex-row w-full" xxstyle="position:relative; z-index:6">
    <NavigationDrawer/>
    <div class="xxpvflex flex basis-auto grow shrink flex-col" style="padding-right:1rem;margin-right:-1rem">
      <ToolBar/>
      <slot/>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import NavigationDrawer from "@/components/common/navigation/navigation/NavigationDrawer.vue";
import ToolBar from "@/components/common/navigation/navigation/ToolBar.vue";

export default defineComponent({
  name: 'NavigationToolBar',
  components: { ToolBar, NavigationDrawer },
});
</script>
